/** @module ProductSpec/SizeChart/ProductGroupView */
define([
	"dojo/_base/declare",
	"csi/_base/underscore",
	"csi/html",
    "csi/html/Widget",
	"csi/widget/FormGroupContainer",
	"csi/widget/MockSizeChartPropertiesChanging",
	"csi/xml"
], function(declare,_,html,HtmlWidget,FormGroupContainer,MockSizeChart,xml) {
	/**
	 * This is view widget for Size Chart -> Product Group selection view
	 * UI Path: Home/Styles/Style->Style/Specification/SizeChart->SizeChart/Properties -> "Product Group" tooltip "Edit"
	 * ProductSpec.xml
	 * View Id="ProductGroup" xsi:type="Html"
	 * Template="ProductSpec/SizeChart/ProductGroupView.html"
	 * ControllerClass="ProductSpec/SizeChart/ProductGroupView"
	 */

	return declare(HtmlWidget, {

		/**@property {boolean} saveDisabled - vutton Save disabled status. True for disabled */
		saveDisabled: true,
		/** @property {string} newProductGroup - Product Group new selection */
		newProductGroup: "",
		/** @property {boolean} maintainTolerances - radion group "Maintain Tolerances" selection */
		maintainTolerances: false,
		/** @property {boolean} maintainDimensions - radion group "Maintain Dimensions" selection  */
		maintainDimensions: false,

		/**
		 * @override
		 * Add Size Chart Mockup at the bottom of html view
		 */
		_postView: function() {
			this.inherited(arguments);

			_.delay(()=>{
				new FormGroupContainer({
					additionalWidget: new MockSizeChart({
						excludeGroups: ["baseSize","incrementValues"],
						onClick: values => {
							this.maintainTolerances = values.maintainTolerances;
							this.maintainDimensions = values.maintainDimensions;
							this.refreshSaveBtn();
						}
					})
				}).placeAt("productSizeChartWizard");
			});
		},

		/**
		 * @ovrride
		 * Control enabled/disabled status of dialog Save action button
		 */
		canEnableButton: function(button, idAction) {
			return (idAction == "Save" ? (this.saveDisabled ? false : true) : true );
		},

		/**
		 * Control enabled/disabled status of dialog Save button
		 */
		refreshSaveBtn: function() {
			const jNode = $(this.domNode);
			const jChecked = jNode.find(".csi-size-chart-mock-table-container :not(.dijitDisabled).dijitChecked .dijitCheckBoxInput");
			const numChecked = jChecked.length;
			const numSelectionRequired = 2;
			this.saveDisabled = (numChecked < numSelectionRequired) || !xml.isValidURL(this.newProductGroup);
			this._setActionButtonsDisabled(false);
		}

	});
});